class SerializrType_strip {
    customStripper;
    constructor(customStripper) {
        this.customStripper = customStripper;
    }
    serializer(context) {
        return this.customStripper(context.objectContext.target);
    }
}
export function strip(customStripper) {
    return new SerializrType_strip(customStripper);
}
